export default __webpack_public_path__ + "static/media/creditIcon.7cf85230.svg";